import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import ReactGA from "react-ga";
import { getSurvery } from "../actions/getSurvey";
const SurveyContext = React.createContext({});

const SurveyProvider = ({ children }) => {
  const [isAlreadyAnswered, setIsAlreadyAnswered] = useState(false);
  const [userId, setUserId] = useState(uuidv4());
  const [surveyData, setSurveyData] = useState({
    screens: [{ question: { type: "" } }],
  });

  useEffect(() => {
    async function fetchData() {
      const surveyData = await getSurvery();
      setSurveyData(surveyData);
      checkIfUserAnsweredTodayAlready(surveyData.surveyKey);
      getUserId();
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (typeof surveyData.surveyKey !== "undefined" && !isAlreadyAnswered) {
      ReactGA.event({
        category: "survey_load",
        action: "saw_survey",
        label: surveyData.surveyKey,
      });
    }
  }, [surveyData.surveyKey]);

  function storageAvailable() {
    var test = "test";
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }

  function getUserId() {
    if (storageAvailable()) {
      const userFromLocalStorage = window.localStorage.getItem("userId");
      if (!userId && userId !== "null") {
        window.localStorage.setItem("userId", userId);
        setUserId(userFromLocalStorage);
      }
    }
    setUserId(userId);
  }

  const checkIfUserAnsweredTodayAlready = (surveyKey) => {
    if (storageAvailable()) {
      let dateAnswered = window.localStorage.getItem("dateAnswered");
      const answeredSurveyKey = window.localStorage.getItem("surveyKey");
      const today = new Date();

      if (
        dateAnswered !== null &&
        answeredSurveyKey !== null &&
        answeredSurveyKey === surveyKey
      ) {
        dateAnswered = new Date(dateAnswered);
        if (
          dateAnswered.getDate() === today.getDate() &&
          dateAnswered.getDay() === today.getDay()
        ) {
          setIsAlreadyAnswered(true);
          ReactGA.event({
            category: "reference",
            action: "saw_reference",
            label: "hamadad",
          });
        }
      }
    }
  };

  return (
    <SurveyContext.Provider
      value={{
        screens: surveyData.screens,
        surveyData,
        isAlreadyAnswered,
        setIsAlreadyAnswered,
        userId,
      }}
    >
      {children}
    </SurveyContext.Provider>
  );
};

export { SurveyProvider };

export default SurveyContext;
